import React from 'react';

const ResendConfirmationModal = ({ isOpen, onClose, onConfirm, candidateEmail }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center">
      <div className="bg-white rounded-lg p-6 max-w-md w-full mx-4">
        <h3 className="text-xl font-semibold text-gray-900 mb-4">
          Warning: Previous Attempt Exists
        </h3>
        <div className="space-y-4">
          <p className="text-gray-600">
            The candidate ({candidateEmail}) has already attempted this pre-screening test.
          </p>
          <div className="bg-yellow-50 border-l-4 border-yellow-400 p-4">
            <div className="flex">
              <div className="flex-shrink-0">
                ⚠️
              </div>
              <div className="ml-3">
                <p className="text-sm text-yellow-700">
                  Resending the invite will delete their previous attempt and allow them to take the test again.
                </p>
              </div>
            </div>
          </div>
        </div>
        <div className="mt-6 flex justify-end gap-3">
          <button
            onClick={onClose}
            className="px-4 py-2 bg-gray-100 text-gray-700 rounded-lg hover:bg-gray-200 transition-colors"
          >
            Cancel
          </button>
          <button
            onClick={onConfirm}
            className="px-4 py-2 bg-red-500 text-white rounded-lg hover:bg-red-600 transition-colors"
          >
            Resend Anyway
          </button>
        </div>
      </div>
    </div>
  );
};

export default ResendConfirmationModal; 